import { Stack, TableCell, TableHead, TableRow } from '@mui/material';
import Iconify from 'src/components/Iconify';
import TableHeadTypography from 'src/components/TableHeadTypography';
import useTypographyMediaQuery from 'src/hooks/useTypographyMediaQuery';
import { toggleSort } from './constants';

const sortIcon = (active, direction) =>
  !active ? 'mdi:swap-vertical' : direction === 'asc' ? 'mdi:arrow-up' : 'mdi:arrow-down';

// The column widths and the header row both views share, with sorting on the columns that allow it.
const PortfolioTableHead = ({ columns, sort, onSortChange }) => {
  const { mediumScreen, largeScreen, smallScreen } = useTypographyMediaQuery();

  return (
    <>
      <colgroup>
        {columns.map(column => (
          <col key={column.key} style={{ width: column.width }} />
        ))}
      </colgroup>
      <TableHead sx={{ backgroundColor: '#3f3f3f', borderRadius: 0 }}>
        <TableRow>
          {columns.map(column => {
            const active = sort.column === column.sortKey;

            return (
              <TableCell key={column.key} sx={{ top: 0, p: '8px 16px', verticalAlign: 'middle' }}>
                <Stack
                  direction="row"
                  gap={1}
                  alignItems="center"
                  onClick={
                    column.sortable
                      ? () => onSortChange(toggleSort(sort, column.sortKey))
                      : undefined
                  }
                  sx={{ cursor: column.sortable ? 'pointer' : 'default' }}>
                  <TableHeadTypography
                    hasSorting={active}
                    mediumScreen={mediumScreen}
                    largeScreen={largeScreen}
                    smallScreen={smallScreen}>
                    {column.label}
                  </TableHeadTypography>
                  {column.sortable ? (
                    <Iconify
                      icon={sortIcon(active, sort.direction)}
                      width={14}
                      height={14}
                      color={active ? '#7DFF92' : '#9CA3AF'}
                    />
                  ) : null}
                </Stack>
              </TableCell>
            );
          })}
        </TableRow>
      </TableHead>
    </>
  );
};

export default PortfolioTableHead;
